export class AppUrl {
  host: string = "https://admapp-homologacao.at3.com.br"; // producao - https://admapp.at3.com.br
  host_assine: string = "http://172.20.0.65:6063";
  host_minha_loga: string = "http://localhost:4200/#/";
  host_ms_fatura: string = "https://sgt.loga.net.br/z25f6ab772";
}



// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/app-url.ts